<app-list-task-form [tasks]="tasks$ | async"  [loading]="loading$ | async" [contacts]="contacts$ | async"
    [stages]="stages$ | async" [answerables]="answerables$ | async" [taskContacts]="taskContacts$ | async"
    (deleteTask$)="onDeleteTask($event)" (createAnswerable$)="onCreateAnswerable($event)"
    [states]="states$ | async">
</app-list-task-form>